import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "link-saver" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = { class: "added-links" }
const _hoisted_4 = { class: "input-controls" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Popconfirm = _resolveComponent("Popconfirm")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Input, {
      modelValue: $data.url,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.url) = $event)),
      "vread-from": "valid",
      "onUpdate:valid": $event => (($data.valid) = $event),
      type: "url",
      disabled: $options.limit
    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid", "disabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        disabled: !$data.url,
        small: "",
        onClick: _cache[1] || (_cache[1] = $event => ($data.url = ''))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Discard")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_Button, {
        disabled: !$options.can_add,
        small: "",
        primary: "",
        onClick: _cache[2] || (_cache[2] = $event => ($options.addLink()))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Add")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (_, i) => {
        return (_openBlock(), _createBlock(_component_Input, {
          key: i,
          modelValue: _ctx.value[i],
          "onUpdate:modelValue": $event => ((_ctx.value[i]) = $event),
          type: "url",
          class: "link"
        }, {
          custom_icon: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Popconfirm, {
                width: "max-content",
                "confirm-button-text": "Yes",
                "cancel-button-text": "No",
                title: "Are you sure you want to delete this source?",
                teleported: false,
                onConfirm: $event => ($options.onDelete(i))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    class: "pointer",
                    icon: "trash-04",
                    stroke: "var(--gray-500)"
                  })
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onConfirm"])
            ])
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}